/* bb-accordion-format.js  (BarrierBoss)
   Formats ONLY the Warranty + Specifications PDP accordions' .rte content into a
   scannable, bold-label definition list. Client-side, PDP-only, idempotent.
   Touches nothing else (no buy box, no other tabs). If content contains links/
   images/lists/media it bails (leaves original untouched). Safe to load on any page.
   Deploy target: assets/bb-accordion-format.js on BOTH the USA and CA themes,
   referenced from sections/product-template.liquid via asset_url. */
(function () {
  if (window.__bbAccFmt) return; window.__bbAccFmt = true;

  var CSS = '.bb-acc-list{margin:0}'
    + '.bb-acc-h{font-weight:700;margin:14px 0 5px;font-size:13px;letter-spacing:.02em;color:#1a1a1a}'
    + '.bb-acc-h:first-child{margin-top:0}'
    + '.bb-acc-row{margin:0 0 8px;line-height:1.55}'
    + '.bb-acc-row:last-child{margin-bottom:0}'
    + '.bb-acc-row strong{font-weight:700;color:#1a1a1a}';

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function injectCSS(){
    if (document.getElementById('bb-acc-css')) return;
    var st = document.createElement('style'); st.id = 'bb-acc-css'; st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  // Standalone ALL-CAPS header line (e.g. MEASUREMENTS) with no separator.
  function isHeader(line){
    return /^[A-Z0-9][A-Z0-9 &/()'.\-]{2,}$/.test(line) && line.indexOf(':') < 0 && line.indexOf('—') < 0;
  }

  function fmt(rte){
    if (!rte || rte.getAttribute('data-bbfmt') === '1') return;
    // Only format plain metafield text. If there is richer markup, leave it alone.
    if (rte.querySelector('a,img,table,ul,ol,iframe,video')) return;

    var html = rte.innerHTML
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/(p|div|h[1-6])>/gi, '\n');
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var text = (tmp.textContent || '');
    var lines = text.split('\n')
      .map(function (s){ return s.replace(/ /g, ' ').trim(); })
      .filter(function (s){ return s.length; });
    if (lines.length < 2) return; // single-line (short warranty / graceful fallback) — leave as-is

    var out = '';
    lines.forEach(function (line){
      if (isHeader(line)) { out += '<div class="bb-acc-h">' + esc(line) + '</div>'; return; }
      var em  = line.indexOf(' — '); // " — " em-dash separator
      var col = line.indexOf(': ');
      var idx = -1, sep = '';
      if (em >= 0 && (col < 0 || em < col)) { idx = em; sep = ' — '; }
      else if (col >= 0) { idx = col; sep = ': '; }
      if (idx >= 0) {
        var label = line.slice(0, idx).trim();
        var rest  = line.slice(idx + sep.length).trim();
        // Only bold reasonably short "labels/headers" — not long sentences that merely contain a dash.
        if (label.length > 0 && label.length <= 42) {
          out += '<div class="bb-acc-row"><strong>' + esc(label) + '</strong>' + esc(sep) + esc(rest) + '</div>';
          return;
        }
      }
      out += '<div class="bb-acc-row">' + esc(line) + '</div>';
    });

    rte.innerHTML = '<div class="bb-acc-list">' + out + '</div>';
    rte.setAttribute('data-bbfmt', '1');
  }

  function run(){
    injectCSS();
    var blocks = document.querySelectorAll('.product_description_accrordion');
    for (var i = 0; i < blocks.length; i++) {
      var head = blocks[i].querySelector('.product_accordion__heading');
      if (!head) continue;
      var h = (head.textContent || '').toLowerCase();
      if (h.indexOf('warranty') < 0 && h.indexOf('specification') < 0) continue;
      fmt(blocks[i].querySelector('.product_accordion__content .rte'));
    }
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  setTimeout(run, 1500); // catch late-injected metafield content
})();
